import TimeType from "./TimeType";
import dayjs from "dayjs";

export class PollItem {
    id: string;
    appointmentId: string;
    date: Date;
    timeType: TimeType;
    comment: string | null;

    constructor(id: string, appointmentId: string, date: Date, timeType: TimeType, comment: string | null = null) {
        this.id = id;
        this.appointmentId = appointmentId;
        this.date = date;
        this.timeType = timeType;
        this.comment = comment;
    }

    static fromJson(data: any): PollItem {
        return new PollItem(
            data.id,
            data.appointmentId,
            dayjs(data.date).toDate(),
            data.timeType,
            data.comment,
        )
    }
}